//==============================
// VENDOR ACTION SCRIPT
// (Revised w/ Hardcoded Tax & Fees Toggles + Empty Cart Logic + Discount Placement)
//==============================
window.initVendorAction = function() {
  console.log("[initVendorAction] Initializing vendor action script...");

  //--------------------------------------------------------------------------
  // 1. GLOBAL TOGGLES (default enabled)
  //--------------------------------------------------------------------------
  console.log("[initVendorAction] Setting default toggles for Taxes and Fees to ON.");
  window.taxEnabled = true;
  window.feesEnabled = true;

  //--------------------------------------------------------------------------
  // 2. LOAD OR INIT CART
  //--------------------------------------------------------------------------
  if (localStorage.getItem("vendorCart")) {
    window.vendorCart = JSON.parse(localStorage.getItem("vendorCart"));
    console.log("[initVendorAction] Vendor cart loaded from localStorage:", window.vendorCart);
  } else {
    window.vendorCart = [];
    console.log("[initVendorAction] No vendor cart found; initialized as empty array.");
  }

  //--------------------------------------------------------------------------
  // 3. CART DISPLAY (items listing)
  //--------------------------------------------------------------------------
  function updateVendorCartDisplay() {
    console.log("[updateVendorCartDisplay] Updating vendor cart display...");

    var container = document.getElementById("vendor-cart");
    if (!container) {
      console.log("[updateVendorCartDisplay] Vendor cart container not found. Exiting.");
      return;
    }

    // If cart is empty: show "Cart is empty." + force toggles ON + only show "Total $0.00"
    if (window.vendorCart.length === 0) {
      console.log("[updateVendorCartDisplay] Cart is currently EMPTY. Showing total=$0.00 only.");

      // 1) Render "cart is empty" message
      container.innerHTML = `
        <div>
          <img src="https://cdn.shopify.com/s/files/1/0600/3300/7699/files/rose.jpg?v=1736822072" alt="Rose" style="opacity: .1; width:150px; height:150px; object-fit: cover;">
        </div>
      `;

      // 2) Force toggles ON
      window.taxEnabled = true;
      window.feesEnabled = true;

      var taxToggleBtn  = document.getElementById("vendor-cart-toggle-btn");
      var feesToggleBtn = document.getElementById("vendor-cart-fees-toggle-btn");
      if (taxToggleBtn) {
        taxToggleBtn.textContent = "ON";
        taxToggleBtn.style.display = "none";  // Hide the tax toggle button when cart is empty
      }
      if (feesToggleBtn) {
        feesToggleBtn.textContent = "ON";
        feesToggleBtn.style.display = "none"; // Hide the fees toggle button when cart is empty
      }

      // 3) Hide Subtotal, Discount, Taxes, Fees lines, but show total at $0.00
      var subtotalRow  = document.getElementById("vendor-cart-subtotal-row");
      var discountRow  = document.getElementById("vendor-cart-discount-row");
      var taxRow       = document.getElementById("vendor-cart-tax-row");
      var feesRow      = document.getElementById("vendor-cart-fees-row");
      var totalRow     = document.getElementById("vendor-cart-total-row");

      if (subtotalRow) subtotalRow.style.display = "none";
      if (discountRow) discountRow.style.display = "none";
      if (taxRow)      taxRow.style.display      = "none";
      if (feesRow)     feesRow.style.display     = "none";

      // Keep the "Total" row visible
      if (totalRow) {
        totalRow.style.display = "flex";
        var totalVal = document.getElementById("vendor-cart-item-total-value");
        if (totalVal) totalVal.textContent = "$0.00";
      }

      // Save empty cart in localStorage
      localStorage.setItem("vendorCart", JSON.stringify(window.vendorCart));
      return;  // Nothing else to do if cart is empty
    }
    
    // If cart not empty, re-show toggle buttons
    var taxToggleBtn  = document.getElementById("vendor-cart-toggle-btn");
    var feesToggleBtn = document.getElementById("vendor-cart-fees-toggle-btn");
    if (taxToggleBtn)  taxToggleBtn.style.display  = "inline-block";
    if (feesToggleBtn) feesToggleBtn.style.display = "inline-block";

    // Re-show the totals rows
    var subtotalRow = document.getElementById("vendor-cart-subtotal-row");
    var discountRow = document.getElementById("vendor-cart-discount-row");
    var taxRow      = document.getElementById("vendor-cart-tax-row");
    var feesRow     = document.getElementById("vendor-cart-fees-row");
    var totalRow    = document.getElementById("vendor-cart-total-row");

    if (subtotalRow) subtotalRow.style.display = "flex";
    if (taxRow)      taxRow.style.display      = "flex";
    if (feesRow)     feesRow.style.display     = "flex";
    if (totalRow)    totalRow.style.display    = "flex";

    // If cart has items, re-draw them
    var html = "<ul class='vendor-cart-items'>";
    window.vendorCart.forEach(function(item, index) {
      // Ensure vendorKey is set
      if (!item.vendorKey) {
        console.log("[updateVendorCartDisplay] vendorKey missing for item at index", index, 
                    ", setting to global value:", window.vendorKey);
        item.vendorKey = window.vendorKey;
      }

      var customPrice   = parseFloat(item.customPrice) || 0;
      var quantity      = parseInt(item.quantity, 10)  || 0;
      var originalPrice = (item.originalPrice !== undefined)
                          ? parseFloat(item.originalPrice)
                          : customPrice;

      var totalPriceDiscounted = customPrice   * quantity;
      var totalPriceOriginal   = originalPrice * quantity;

      // Show a discounted price if there's a discount in place
      var priceMarkup = "";
      var totalMarkup = "";
      if (window.vendorCartDiscount 
          && item.originalPrice !== undefined 
          && (originalPrice !== customPrice)) {
        // There's a discount in effect
        priceMarkup = "<span class='discounted-price'>$" + customPrice.toFixed(2) + "</span>"
                    + "<span class='original-price' style='text-decoration: line-through; color: #999;'>"
                    + "$" + originalPrice.toFixed(2) + "</span>";

        totalMarkup = "<span class='discounted-total'>$" + totalPriceDiscounted.toFixed(2) + "</span>"
                    + "<span class='original-total' style='text-decoration: line-through; color: #999;'>"
                    + "$" + totalPriceOriginal.toFixed(2) + "</span>";
      } else {
        // No discount
        priceMarkup = "$" + customPrice.toFixed(2);
        totalMarkup = "$" + totalPriceDiscounted.toFixed(2);
      }

      // Build an "header" row with category & total
      var headerHtml = "<div class='item-header' style='display: flex; gap: 1rem; align-items: flex-start;'>"
                     +   "<span class='item-category' style='flex: 1; line-height: 1.2;'>"
                     +      item.variantCategory
                     +   "</span>"
                     +   "<span class='item-total' style='width: fit-content; display: flex; flex-direction: column-reverse;'>"
                     +      totalMarkup
                     +   "</span>"
                     + "</div>";

      // Build the item body
      var bodyHtml   = "<div class='item-body'>"
                     +   "<span class='item-title'>" + item.variantTitle + "</span>";

      // Price row w/multiplier
      bodyHtml += "<div class='price-row' style='display: flex; gap: 8px; margin-top: 4px;'>"
                +   "<span class='item-multiplier' data-index='" + index + "' style='cursor:pointer;'>"
                +       quantity
                +   "</span>"
                +   "<span class='item-price'>" + priceMarkup + "</span>"
                + "</div>";

      // If custom-cut
      if (item.cutDetails) {
        // custom-cut scenario
        bodyHtml += "<div class='custom-cut-actions' style='display: flex; justify-content: space-between; align-items: center; margin-top: 4px;'>"
                  +   "<span class='item-cut-details'>Cut Details: " + item.cutDetails + "</span>"
                  +   "<span class='custom-cut-icons' style='display: flex; align-items: center; gap: 0.5rem;'>";
        if (item.specialInstructions) {
          bodyHtml += "<span class='material-symbols-outlined' title='Special instructions'>notes</span>";
        }
        if (item.isFullMaterial) {
          bodyHtml += "<span class='material-symbols-outlined' title='Full Material + Cut'>check_circle_outline</span>";
        }
        bodyHtml +=   "<span class='edit-link' data-index='" + index + "' style='text-decoration:underline; cursor:pointer; color:blue;'>Edit</span>"
                    + "<span class='remove-link' data-index='" + index + "' style='text-decoration:underline; cursor:pointer; color:red;'>Remove</span>"
                    + "</span>"
                    + "</div>";
      } else {
        // normal items scenario
        bodyHtml += "<button class='vendor-cart-remove' data-index='" + index + "' style='margin-top: 4px;'>Remove</button>";
      }

      bodyHtml += "</div>"; // end .item-body

      // Insert the cut variable & material price in data attributes for reference
      var cutVarAttr = (item.variantCutVariable !== undefined)
                       ? `data-cut-variable='${item.variantCutVariable}'`
                       : `data-cut-variable='0'`;
      var matPriceAttr = (item.materialPrice !== undefined)
                       ? `data-material-price='${item.materialPrice.toFixed(2)}'`
                       : `data-material-price='0'`;

      html += `<li class='vendor-cart-item'
        data-index='${index}'
        data-variant-category='${item.variantCategory}'
        data-title='${item.variantTitle}'
        data-variant-id='${item.variantId}'
        data-sku='${item.sku || ''}'
        data-vendor-key='${item.vendorKey}'
        data-price='${customPrice.toFixed(2)}'
        data-custom-cut='${item.customCut ? "true" : "false"}'
        data-inventory-check='${item.inventory_check ? "true" : "false"}'
        data-quantity='${quantity}'
        data-special-instructions='${item.specialInstructions ? item.specialInstructions : ""}'
        ${cutVarAttr}
        ${matPriceAttr}
      >`
       +  headerHtml
       +  bodyHtml
       + "</li>";
    });

    html += "</ul>";
    container.innerHTML = html;

    // Save updated cart to localStorage
    localStorage.setItem("vendorCart", JSON.stringify(window.vendorCart));

    // Re-bind remove events for normal items
    container.querySelectorAll(".vendor-cart-remove").forEach(function(btn) {
      btn.addEventListener("click", function() {
        var idx = btn.getAttribute("data-index");
        window.vendorCart.splice(idx, 1);

        // Re-apply discount if needed
        if (window.vendorCartDiscount && typeof window.updateCartWithDiscount === "function") {
          window.updateCartWithDiscount();
        }
        updateVendorCartDisplay();
        document.dispatchEvent(new CustomEvent("vendorCartUpdated"));
      });
    });

    // Re-bind remove links for custom-cut items
    container.querySelectorAll(".remove-link").forEach(function(link) {
      link.addEventListener("click", function() {
        var idx = link.getAttribute("data-index");
        console.log("[updateVendorCartDisplay] Custom cut remove clicked, index:", idx);
        window.vendorCart.splice(idx, 1);
        if (window.vendorCartDiscount && typeof window.updateCartWithDiscount === "function") {
          window.updateCartWithDiscount();
        }
        updateVendorCartDisplay();
        document.dispatchEvent(new CustomEvent("vendorCartUpdated"));
      });
    });

    // Re-bind "edit-link" for custom cuts
    container.querySelectorAll(".edit-link").forEach(function(link) {
      link.addEventListener("click", function() {
        var idx = link.getAttribute("data-index");
        // function to open your custom cut modal in EDIT mode
        openCustomCutModalForEdit(idx);
      });
    });

    // Re-bind the inline quantity editor (click the number to edit)
    container.querySelectorAll(".item-multiplier").forEach(function(span) {
      span.addEventListener("click", function() {
        var idx        = span.getAttribute("data-index");
        var currentQty = span.textContent.trim();
        var input      = document.createElement("input");
        input.type     = "number";
        input.min      = "1";
        input.value    = currentQty;
        input.style.width = "50px";

        // Replace the span with the input temporarily
        span.parentNode.replaceChild(input, span);
        input.focus();

        input.addEventListener("blur", function() {
          var newQty = parseInt(input.value, 10) || 1;
          window.vendorCart[idx].quantity = newQty;
          updateVendorCartDisplay();
          document.dispatchEvent(new CustomEvent("vendorCartUpdated"));
        });
      });
    });

    // Bind "Clear Cart" button
    var clearBtn = document.getElementById("vendor-cart-clear");
    if (clearBtn) {
      clearBtn.addEventListener("click", function() {
        window.vendorCart = [];
        localStorage.removeItem("vendorCart");
        updateVendorCartDisplay();
        document.dispatchEvent(new CustomEvent("vendorCartUpdated"));
      });
    }

    // Finally, update the totals (Subtotal, Discount, Taxes, Fees, Total)
    updateCartTotal();

    document.dispatchEvent(new CustomEvent("vendorCartActionsUpdated"));
  } // end updateVendorCartDisplay

  // Expose it globally
  window.updateVendorCartDisplay = updateVendorCartDisplay;

  //--------------------------------------------------------------------------
  // 4. CART TOTALS (Subtotal, Discount, Taxes, Fees, Grand Total)
  //--------------------------------------------------------------------------
  function updateCartTotal() {
    console.log("[updateCartTotal] Updating cart totals...");

    // Grab references to the ROWS:
    var subtotalRow   = document.getElementById("vendor-cart-subtotal-row");
    var discountRow   = document.getElementById("vendor-cart-discount-row");
    var taxRow        = document.getElementById("vendor-cart-tax-row");
    var feesRow       = document.getElementById("vendor-cart-fees-row");
    var totalRow      = document.getElementById("vendor-cart-total-row");

    // Grab references to the numeric spans:
    var subtotalVal   = document.getElementById("vendor-cart-item-subtotal-value");
    var discountVal   = document.getElementById("vendor-cart-item-discount-value");
    var taxVal        = document.getElementById("vendor-cart-item-taxes-value");
    var feesVal       = document.getElementById("vendor-cart-item-fees-value");
    var totalVal      = document.getElementById("vendor-cart-item-total-value");

    // If any missing, log error and return
    if (!subtotalRow || !discountRow || !taxRow || !feesRow || !totalRow
        || !subtotalVal || !discountVal || !taxVal || !feesVal || !totalVal) {
      console.error("[updateCartTotal] One or more required elements not found.");
      return;
    }

    // 1) Calculate the raw subtotal
    var originalTotal   = 0;
    var discountedTotal = 0;
    window.vendorCart.forEach(function(item) {
      var qty     = parseInt(item.quantity, 10) || 0;
      var cPrice  = parseFloat(item.customPrice) || 0;
      var oPrice  = (item.originalPrice !== undefined) ? parseFloat(item.originalPrice) : cPrice;
      originalTotal   += (oPrice * qty);
      discountedTotal += (cPrice * qty);
    });

    var discountAmount = originalTotal - discountedTotal;
    if (discountAmount < 0) discountAmount = 0; // safety
    var rawSubtotal = discountedTotal;

    // 2) Show numeric values
    subtotalVal.textContent = "$" + rawSubtotal.toFixed(2);

    // If discount > 0, show row. Otherwise hide it
    if (discountAmount > 0) {
      discountRow.style.display = "flex";
      discountVal.textContent = "-$" + discountAmount.toFixed(2);
    } else {
      discountRow.style.display = "none";
    }

    // 3) Taxes & Fees
    if (window.taxEnabled) {
      taxVal.textContent = "$" + (rawSubtotal * 0.07).toFixed(2);
    } else {
      taxVal.textContent = "EXEMPT";
    }

    if (window.feesEnabled) {
      feesVal.textContent = "$" + (rawSubtotal * 0.03).toFixed(2);
    } else {
      feesVal.textContent = "OFF";
    }

    // 4) Grand total
    var feesValue  = window.feesEnabled ? rawSubtotal * 0.03 : 0;
    var taxValue   = window.taxEnabled  ? rawSubtotal * 0.07 : 0;
    var grandTotal = rawSubtotal + feesValue + taxValue;
    totalVal.textContent = "$" + grandTotal.toFixed(2);

    console.log("[updateCartTotal]",
                "Subtotal=",   rawSubtotal.toFixed(2),
                "Discount=",   discountAmount.toFixed(2),
                "Tax=",        taxValue.toFixed(2),
                "Fees=",       feesValue.toFixed(2),
                "GrandTotal=", grandTotal.toFixed(2));
  }

  //--------------------------------------------------------------------------
  // 5. MONETARY INPUT BEHAVIOR (for custom add forms)
  //--------------------------------------------------------------------------
  function initMonetaryInput(container) {
    console.log("[initMonetaryInput] Initializing monetary input in container:", container);

    var priceInput = container.querySelector(".v-act-price-input");
    if (!priceInput) return;

    var lastValid = "";
    var regex     = /^\d*\.?\d{0,2}$/; // up to 2 decimals

    priceInput.addEventListener("input", function() {
      var currentValue = priceInput.value;
      if (regex.test(currentValue)) {
        lastValid = currentValue;
      } else {
        priceInput.value = lastValid;
      }
    });

    priceInput.addEventListener("blur", function() {
      var value = priceInput.value;
      if (value === "") {
        priceInput.value = "0.00";
        return;
      }
      if (value.indexOf(".") === -1) {
        // no decimal found, add .00
        value = value + ".00";
      } else {
        var parts = value.split(".");
        if (parts[1].length === 0) {
          value = parts[0] + ".00";
        } else if (parts[1].length === 1) {
          value = parts[0] + "." + parts[1] + "0";
        } else if (parts[1].length > 2) {
          value = parts[0] + "." + parts[1].substring(0, 2);
        }
      }
      priceInput.value = value;
    });
  }

  //--------------------------------------------------------------------------
  // 6. MAIN "ADD" BUTTON FOR A FORM
  //--------------------------------------------------------------------------
  function initMainAddButton(container) {
    console.log("[initMainAddButton] Initializing main add button for container:", container);
    var mainAddBtn = container.querySelector('.v-act-main-add-btn');
    if (mainAddBtn && !mainAddBtn.dataset.bound) {

      mainAddBtn.addEventListener('click', function(e) {
        console.log("[initMainAddButton] Main add button clicked.");

        // 1) Grab price & quantity
        var priceVal = container.querySelector('.v-act-price-input').value;
        var qtyVal   = container.querySelector('.v-act-quantity-input').value;
        console.log("[initMainAddButton] Price value:", priceVal, "Quantity value:", qtyVal);

        // 2) Find the parent row with a data-variant-id
        var parentRow = e.target.closest('.open-variant-drawer');
        if (!parentRow) {
          console.log("[initMainAddButton] Parent row with .open-variant-drawer not found; attempting fallback.");
          parentRow = document.getElementById('collection-list-row');
        }

        if (!parentRow) {
          console.error("[initMainAddButton] No parent row found even after fallback. Cannot determine variant details.");
          alert("Variant details not found. Please refresh the page or contact support.");
          return;
        }

        // Retrieve variant details
        var variantId       = parentRow.getAttribute('data-variant-id') || "";
        var variantTitle    = parentRow.getAttribute('data-variant-title') || ("Variant " + variantId);
        var variantCategory = parentRow.getAttribute('data-variant-category') || "";
        var sku             = parentRow.getAttribute('data-sku') || "";
        var specialInstructions = parentRow.getAttribute('data-special-instructions')  || "";
      
        console.log("[initMainAddButton] Variant details: ID =", variantId,
                    ", Title =", variantTitle, ", Category =", variantCategory, ", SKU =", sku);

        // Fallback for variantCategory if missing or "null"
        if (variantCategory === "null" || !variantCategory) {
          var fallbackElem = document.getElementById('collection-list-row');
          if (fallbackElem) {
            variantCategory = fallbackElem.getAttribute('data-variant-category') || variantCategory;
            console.log("[initMainAddButton] Fallback category found:", variantCategory);
          }
        }

        // 4) Validate price and quantity
        if (priceVal === "" || qtyVal === "" || parseFloat(priceVal) === 0 || parseInt(qtyVal, 10) === 0) {
          console.log("[initMainAddButton] Invalid price or quantity. Price:", priceVal, "Quantity:", qtyVal);
          alert("Please enter a valid price and quantity.");
          return;
        }

        // 5) Build the cart item object (inventory_check = true by default).
        //    We'll also store "materialPrice" so we have the full piece price
        //    accessible in the cart item for editing custom cuts.
        var item = {
          variantId:       variantId,
          variantTitle:    variantTitle,
          variantCategory: variantCategory,
          sku:             sku,
          originalPrice:   parseFloat(priceVal),
          customPrice:     parseFloat(priceVal),
          quantity:        parseInt(qtyVal, 10),
          vendorKey:       window.vendorKey,
          inventory_check: true,
          specialInstructions: specialInstructions,
          materialPrice:   parseFloat(priceVal) // <--- storing full piece price
        };

        console.log("[initMainAddButton] Adding item to vendorCart:", item);

        // 6) Push the item to vendorCart, update display
        window.vendorCart.push(item);
        if (window.vendorCartDiscount && typeof window.updateCartWithDiscount === "function") {
          window.updateCartWithDiscount();
        }
        updateVendorCartDisplay();
        document.dispatchEvent(new CustomEvent('vendorCartUpdated'));
      });

      mainAddBtn.dataset.bound = "true";
      console.log("[initMainAddButton] Main add button event bound.");
    } else {
      console.log("[initMainAddButton] Main add button already bound or not found in container:", container);
    }
  }

  function initCustomCutForm(container) {
    initMonetaryInput(container);
    initMainAddButton(container);
  }

  function initForms() {
    var forms = document.querySelectorAll(".v-act-custom-cut-form");
    forms.forEach(function(form) {
      initCustomCutForm(form);
    });
  }

  //--------------------------------------------------------------------------
  // 7. EVENT: On vendorCartUpdated
  //--------------------------------------------------------------------------
  document.addEventListener("vendorCartUpdated", function() {
    console.log("[vendorCartUpdated] Event received - re-checking discount & re-drawing cart.");
    if (window.vendorCartDiscount && typeof window.updateCartWithDiscount === "function") {
      window.updateCartWithDiscount();
    }
    updateVendorCartDisplay();
  });

  //--------------------------------------------------------------------------
  // 8. DOM LOADED: Initialize forms, display cart
  //--------------------------------------------------------------------------
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function() {
      initForms();
      updateVendorCartDisplay();
    });
  } else {
    initForms();
    updateVendorCartDisplay();
  }

  //--------------------------------------------------------------------------
  // 9. TAX & FEES TOGGLE BUTTONS
  //--------------------------------------------------------------------------
  var taxToggleBtn = document.getElementById("vendor-cart-toggle-btn");
  if (taxToggleBtn) {
    taxToggleBtn.addEventListener("click", function() {
      window.taxEnabled = !window.taxEnabled;
      taxToggleBtn.textContent = window.taxEnabled ? "ON" : "OFF";
      updateCartTotal();
    });
  }

  var feesToggleBtn = document.getElementById("vendor-cart-fees-toggle-btn");
  if (feesToggleBtn) {
    feesToggleBtn.addEventListener("click", function() {
      window.feesEnabled = !window.feesEnabled;
      feesToggleBtn.textContent = window.feesEnabled ? "ON" : "OFF";
      updateCartTotal();
    });
  }

  console.log("[initVendorAction] VendorAction initialization complete.");
}; // end initVendorAction

// Immediately invoke
window.initVendorAction();
